<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <h2 class="noMarginHeader">Partner Info</h2>
  </div>
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
    <button mat-raised-button color="primary" title="Copy to Clipboard" (click)="clipboardCopy()">
      Copy to Clipboard
    </button>
    &nbsp;&nbsp;
    <button mat-button mat-dialog-close="Cancel" mat-raised-button color="basic" aria-label="Cancel" title="Close">
      Close
    </button>
  </div>
</div>

<section [hidden]="partner == null">
  <mat-dialog-content>
    <div fxLayout="row wrap" class="matero-row">
      <mat-card [ngClass]="{
        'bg-gray-700': sharedService.darkMode,
        'bg-indigo-50': !sharedService.darkMode}" fxFlex="100">
        <div fxLayout="row wrap" class="matero-row">
          <mat-form-field [style.width.%]="95">
            <strong>Partner Name: </strong> {{partner.partnerName}}
          </mat-form-field>
        </div>

        <div fxLayout="row wrap" class="matero-row">
          <mat-form-field [style.width.%]="95">
            <strong>Partner URL:</strong>
            <a [href]="env.baseUrl + '/Partner/Access/' + partner.accessUriGuid" target="_blank" rel="noopener noreferrer">
              {{env.baseUrl}}/Partner/Access/{{partner.accessUriGuid}}
            </a>
          </mat-form-field>
        </div>

        <div fxLayout="row wrap" class="matero-row">
          <mat-form-field [style.width.%]="95">
            <strong>Partner Email: </strong> {{partner.partnerEmail}}
          </mat-form-field>
        </div>

        <div fxLayout="row wrap" class="matero-row" *ngIf="partner.passKeys.length > 0">
          <div fxFlex="100" fxFlex.lt-sm="100">
            <span><strong>Access Keys ({{partner.passKeys.length}}) </strong></span>
            <br /><br />
            <ul>
              <li *ngFor="let item of partner.passKeys; let i = index;">
                {{item.passKey}} &nbsp;&nbsp; {{item.comments}}
              </li>
            </ul>
          </div>
        </div>
      </mat-card>
    </div>
  </mat-dialog-content>
</section>